import { createPortal } from 'react-dom';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function DialogVideo(props: any) {
    const { useState, useEffect } = useGlobal();
    const [open, setOpen] = useState(true);
    const [isClient, setIsClient] = useState(false);
    const { callback } = props;

    const handleClose = () => {
        callback && callback();
        setOpen(false);
    };

    useEffect(() => {
        if (typeof window !== undefined) {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            {isClient &&
                createPortal(
                    <dialog className={`dialog dialog-video ${css['dialog-video']}`} open={open}>
                        <div className="video-box">
                            <svg
                                className="close"
                                stroke="#fff"
                                fill="#DDD"
                                strokeWidth="0"
                                viewBox="0 0 512 512"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={handleClose}
                            >
                                <path d="M256 48C140.559 48 48 140.559 48 256c0 115.436 92.559 208 208 208 115.435 0 208-92.564 208-208 0-115.441-92.564-208-208-208zm104.002 282.881l-29.12 29.117L256 285.117l-74.881 74.881-29.121-29.117L226.881 256l-74.883-74.881 29.121-29.116L256 226.881l74.881-74.878 29.12 29.116L285.119 256l74.883 74.881z"></path>
                            </svg>
                            <video className="inner-video" width="100%" height="100%" autoPlay controls playsInline preload="auto" {...props} />
                        </div>
                    </dialog>,
                    document.body,
                )}
            {/* <style global jsx>
                {`
                    .ecoflow-frame-header {
                        z-index: 100 !important;
                    }
                    #allContentContainer {
                        z-index: 200;
                    }
                    .announcement-bar {
                        z-index: 240;
                    }
                    .back-to-top {
                        z-index: 260;
                    }
                `}
            </style> */}
        </>
    );
}
